import { render, staticRenderFns } from "./1382_将二叉搜索树变平衡.md?vue&type=template&id=213157b3&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports